<template>
  <div class="region-home position-relative">
    <b-overlay :show="flagBusy">
      <pagination :meta="flagsMeta" place-holder="سەھىپە نامىنى كىرگۈزۈپ ئىزدەڭ" @change-page="onChangePage" @refresh="onRefresh">
        <b-button slot="action" :to="{name: 'flag.store'}" class="btn btn-label-success btn-sm border-0">
          يېڭىدىن قوشۇش
        </b-button>
      </pagination>
      <b-row>
        <b-col v-for="flag in flags" :key="`language_${flag.id}`" md="3" sm="6">
          <portlet :title="flag.title" body-fluid body-class="px-3 pb-3 pt-0" headNoBorder head-class="px-2" head-size="sm">
            <template slot="toolbar">
              <b-dropdown v-b-tooltip title="مەشغۇلات" toggle-class="text-decoration-none border-0 btn btn-clean btn-sm btn-icon btn-icon-md" no-caret>
                <template v-slot:button-content>
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-text >
                  <b-checkbox switch v-model="flag.is_show" @change="onChangeSwitch( flag.id, 'is_show', $event )"> ھالىتى </b-checkbox>
                </b-dropdown-text>
                <b-dropdown-divider />
                <b-dropdown-item :to="{name: 'flag.edit', params: {id: flag.id}}">
                  <i class="fa fa-info-circle"></i> تەھرىرلەش
                </b-dropdown-item>
                <b-dropdown-item @click="onClickDelete(flag.id)">
                  <i class="fa fa-trash"></i> ئۆچۈرۈش
                </b-dropdown-item>
              </b-dropdown>
            </template>
            <template slot="body">
              <div class="kt-widget-item-container">
                <div class="kt-widget kt-widget--user-profile-2">
                  <div class="kt-widget__body">
                    <div class="kt-widget__item">
                      <div class="kt-widget__contact">
                        <span class="kt-widget__label">كىنو سانى: </span>
                        <span class="kt-widget__data"> {{ flag.films_count }} پارچە </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </portlet>
        </b-col>
      </b-row>
      <no-result :visible="!flags.length" background="warning" title="ئۇچۇر تېپىلمىدى" desc="مۇناسىۋەتلىك ئ‍ۇچۇر تېپىلمىدى، يېڭىدىن سەھىپە قوشۇڭ." >
        <template slot="action">
          <b-button :to="{name: 'flag.store'}" class="btn-custom btn-bold btn-upper btn-font-sm  btn-warning">سەھىپە قوشۇش</b-button>
        </template>
      </no-result>
    </b-overlay>
  </div>
</template>

<script>
  import Portlet from "@v@/partials/content/Portlet";
  import NoResult from "@v@/partials/content/NoResult";
  import flagMixin from "@m@/flag.mixin";
  import formBusyMixin from "@m@/common/formBusy.mixin";
  import pagination from "@v@/components/paginate";
  import BreadCrumbs from "@c@/breadcrumbs.service";
  import commonMethodMixin from "@m@/common/common.method.mixin";
  import msgBoxConfirmMixin from "@m@/common/msgBoxConfirmMixin";
  import {SET_FLAG_ERROR} from "@/store/modules/flag.module";

  export default {
    name: "index",
    components: { Portlet, pagination, NoResult },
    mixins: [flagMixin, formBusyMixin, commonMethodMixin, msgBoxConfirmMixin],
    data(){
      return {
        flagBusy: false,
        page: 1,
        title: ''
      };
    },
    computed: {},
    created() {
      this.getFlags();
    },
    mounted() {
      BreadCrumbs.setBreadCrumb([]);
      BreadCrumbs.addBreadCrumb({title: 'سەھىپە باشقۇرۇش', route: {name: 'flag.home'}});
      BreadCrumbs.addBreadCrumb({title: 'بارلىق سەھىپىلەر'});
    },
    methods: {
      onChangePage(e){
        let { title, page } = e;
        this.page = page; this.title = title;
        this.getFlags(page, title);
      },
      onRefresh(title){
        this.getFlags(1, title);
      },
      onChangeSwitch(id, column, value){
        this.switchColumn({
          resource: 'films/flags',
          id, column, mutationType: SET_FLAG_ERROR,
          begin: ()=>{ this.showBusy('flagBusy') },
          after: ()=>{ this.hideBusy('flagBusy') },
        });
      },
      onClickDelete(id){
        this.msgBoxConfirm({
          message: 'مەزكۇر سەھىپە ئۇچۇرىنى ئۆچۈرسىڭىز ئەسلىگە قايتۇرالمايسىز، يەنىلا ئۆچۈرۈشنى جەزىملەشتۈرەمسىز ؟',
          confirmCallback: confirm=>{
            if ( confirm ){
              this.deleteModel({
                id, mutationType: SET_FLAG_ERROR, resource: 'films/flags',
                begin: ()=>{ this.showBusy('flagBusy')},
                after: ()=>{
                  let { title, page } = this;
                  this.getFlags(page, title);
                  this.hideBusy('flagBusy');
                },
              })
            }
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
